module.exports = __webpack_public_path__ + "static/20230619_052-46a7acb0e25e8137bb6789232719ffae.jpg";